<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Rundmail Einstellungen</h4>
      </div>
      <form @submit.prevent="save()">
        <div class="card-body">
          <div class="form-group row">
            <col-label for="batchSize">Batch Size</col-label>
            <div>
              <input
                type="number"
                v-model="batchSize"
                step="1"
                min="1"
                id="batchSize"
              />
            </div>
          </div>
          <div class="form-group row">
            <col-label for="offlineDays">Offline Begrenzung in Tage</col-label>
            <div>
              <input
                type="number"
                v-model="offlineDays"
                step="1"
                min="1"
                id="offlineDays"
              />
            </div>
          </div>
        </div>
        <div class="card-footer">
          <input type="submit" class="btn btn-primary" value="Speichern" />
        </div>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.$store
      .dispatch("setting/all")
      .then(() => {
        this.batchSize = this.$store.getters["setting/key"](
          "circularMailMessageBatchSize"
        );
        this.offlineDays = this.$store.getters["setting/key"](
          "circularmailOfflineDays"
        );
      })
      .then(() => (this.loading = false));
  },
  data() {
    return {
      batchSize: 1,
      loading: true
    };
  },
  methods: {
    save() {
      this.$store
        .dispatch("setting/update", {
          circularMailMessageBatchSize: this.batchSize,
          circularmailOfflineDays: this.offlineDays
        })
        .then(() =>
          this.$notify({
            title: "Einstellungen gespeichert",
            type: "success"
          })
        );
    }
  }
};
</script>
